import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none"><path d="M16.97 9.005c-.372-.069-.724-.289-1.429-.73L13.5 7l3.414-3.414A2 2 0 0 1 18.328 3H21v2.672a2 2 0 0 1-.586 1.414l-1.135.94c-.64.53-.96.795-1.32.913a2 2 0 0 1-.988.066ZM4.355 14.146a1.14 1.14 0 0 1 1.417-.155L10.5 17l-.25.25.573.573a.604.604 0 0 1 0 .854l-.97.97a.5.5 0 0 1-.707 0L7.75 18.25 6 20v.646a.354.354 0 0 1-.604.25l-2.292-2.292a.354.354 0 0 1 .25-.604H4l1.75-1.75-1.396-1.396a.5.5 0 0 1 0-.708ZM5.672 3a2 2 0 0 1 1.414.586L17.25 13.75l.573-.573a.604.604 0 0 1 .854 0l.97.97a.5.5 0 0 1 0 .707L18.25 16.25 20 18h.646a.354.354 0 0 1 .25.604l-2.292 2.292a.353.353 0 0 1-.604-.25V20l-1.75-1.75-1.396 1.396a.5.5 0 0 1-.708 0l-.97-.97a.604.604 0 0 1 0-.853l.574-.573L3.586 7.086A2 2 0 0 1 3 5.672V3h2.672Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
